<template>
  <v-dialog
    v-model="open"
    max-width="290"
    lazy
  >
    <v-card>
      <v-card-title class="headline">Delete</v-card-title>

      <v-card-text>
        Are you sure you want to delete the selected object? This cannot be undone.
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="green darken-1"
          flat="flat"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat="flat"
          @click="confirmDelete"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteObject',
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    confirmDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style>

</style>
